import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Heart, Search } from "lucide-react";
import Logo from "./Logo";
import { MAIN_SLUG } from "@/lib/api";

export default function Header() {
  const navigate = useNavigate();
  const [q, setQ] = useState("");

  const submit = (e) => {
    e.preventDefault();
    navigate(q ? `/?q=${encodeURIComponent(q)}` : "/");
  };

  return (
    <header className="sticky top-0 z-50 border-b border-[#EFE9DF] bg-white/95 backdrop-blur-md">
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between gap-4 px-4 sm:px-6">
        <Link to="/" data-testid="header-logo" className="shrink-0">
          <Logo />
        </Link>

        <form onSubmit={submit} className="hidden flex-1 justify-center md:flex">
          <div className="relative w-full max-w-sm">
            <Search className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-[#9E9085]" />
            <input
              data-testid="header-search-input"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Buscar vaquinhas de pets..."
              className="h-11 w-full rounded-full border border-[#EFE9DF] bg-[#F7F3ED] pl-11 pr-4 text-sm font-semibold outline-none transition focus:border-[#FF6D47] focus:bg-white"
            />
          </div>
        </form>

        <nav className="hidden items-center gap-6 lg:flex">
          <a href="/#como-ajudar" className="text-sm font-bold text-[#6E6259] transition hover:text-[#FF6D47]">
            Como ajudar
          </a>
          <a href="/#seguranca" className="text-sm font-bold text-[#6E6259] transition hover:text-[#FF6D47]">
            Transparência
          </a>
        </nav>

        <button
          data-testid="header-donate-btn"
          onClick={() => navigate(`/vaquinha/${MAIN_SLUG}`)}
          className="flex h-11 items-center gap-2 rounded-full bg-[#FF6D47] px-5 text-sm font-extrabold text-white shadow-[0_6px_18px_rgba(255,109,71,0.4)] transition hover:-translate-y-0.5 hover:bg-[#E85732]"
        >
          <Heart className="h-4 w-4 fill-white" /> Doar agora
        </button>
      </div>
    </header>
  );
}
